import { Location } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Debate, DebatesService } from 'core/index';
import { Widget } from '@widgets/widget';
import {
  DebatesTotalWidget,
  DebatesMeanVotesWidget,
  DebatesCertifiedWidget,
  DebatesCancelledWidget
} from './debates-widgets';

@Component({
  selector: 'lms-debates',
  templateUrl: './debates.component.html',
  styleUrls: ['./debates.component.scss']
})
export class DebatesComponent implements OnInit {
  @Input() listId: string;
  @Input() groupId: string;
  @Input() options: any;
  public listOptions: any;
  public data: any;

  public totalWidget: Widget;
  public meanVotesWidget: Widget;
  public certifiedWidget: Widget;
  public canceledWidget: Widget;

  constructor(
    public route: ActivatedRoute,
    public location: Location,
    public debatesService: DebatesService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.totalWidget = DebatesTotalWidget(this.groupId);
    this.meanVotesWidget = DebatesMeanVotesWidget(this.groupId);
    this.certifiedWidget = DebatesCertifiedWidget(this.groupId);
    this.canceledWidget = DebatesCancelledWidget(this.groupId);
  }

  goBack(): void {
    this.location.back();
  }
}
